<template>
  <div>
    <b-modal id="deleteModal" v-model="modalShow" title="査定見積の削除">
      <p class="mb-0">
        この査定見積を削除しますか？<br />この操作は取り消すことができません。
      </p>
      <template #modal-footer>
        <b-button variant="link" @click="modalShow = false">
          キャンセル
        </b-button>
        <b-button variant="danger" @click="removeEstimation()">
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="15"
            viewBox="0 0 448 512"
            class="mr-2"
          >
            <path
              fill="currentColor"
              d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
              class=""
            ></path>
          </svg>
          削除する
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      modalShow: false,
      estimateIndex: null,
    };
  },
  methods: {
    ...mapActions({
      doRemoveEstimation: "doRemoveEstimation",
    }),

    show(index) {
      this.estimateIndex = index;
      this.modalShow = true;
    },
    removeEstimation() {
      this.doRemoveEstimation(this.estimateIndex);
      this.modalShow = false;
    },
  },
};
</script>